
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { PromptParameter } from '../../data-access/rephrase';
import { GetFlag } from '../..';

@Component({
  name: 'BoxList'
})
export default class BoxList extends Vue {
  @Prop() parameterName!: string;

  @Getter('langs', { namespace: 'rephrase' }) langs!: string[];
  @Getter('promptParameters', { namespace: 'rephrase' }) promptParameters!: PromptParameter[];
  @Getter('currentPromptId', { namespace: 'rephrase' }) currentPromptId!: number;

  @Action('updatePromptParameters', { namespace: 'rephrase' }) updatePromptParameters!: any;

  GetFlag = GetFlag;

  lang: string = "";
  listParameters: { firstLine: string; secondLine: string }[] = [];
  parameters: any = {};

  created() {
    this.lang = this.langs[0];
    this.getParameters();
  }

  @Watch('currentPromptId')
  onCurrentPromptChanged() {
    this.getParameters();
  }

  @Watch('promptParameters')
  onPromptParametersChanged() {
    this.getParameters();
  }

  getParameters() {
    this.parameters = this.promptParameters
      .find(param => param.name === this.parameterName && param.promptId === this.currentPromptId && param.lang === this.lang) || { value: '' };
    this.parseParameters();
  }

  parseParameters() {
    // Convert the string to an array of objects
    // The regex matches the following pattern: "User: {firstLine} Assistant: {secondLine}"
    // Exemple: "User: Hello Assistant: Hi User: Bye Assistant: Goodbye"
    // Will give the following array: [{firstLine: "Hello", secondLine: "Hi"}, {firstLine: "Bye", secondLine: "Goodbye"}]

    const regex = /User:(.*?)Assistant:(.*?)(?=User:|$)/gs;
    const linesArray = [];
    let match;

    while ((match = regex.exec(this.parameters.value)) !== null) {
        linesArray.push(match[1], match[2]);
    }

    this.listParameters = [];
    for (let i = 0; i < linesArray.length; i += 2) {
      this.listParameters.push({
        firstLine: linesArray[i] ? linesArray[i] : '',
        secondLine: linesArray[i + 1] ? linesArray[i + 1] : ''
      });
    }
  }

  updateParameter(outerIndex: number, lineKey: 'firstLine' | 'secondLine', value: string) {
    this.listParameters[outerIndex][lineKey] = value.replace(/[{}]/g, ''); // Remove forbidden chars 
    this.pushParameters();
  }

  pushParameters() {
    if(!this.parameters.promptId){
      this.parameters = {
        name: this.parameterName,
        promptId: this.currentPromptId,
        lang: this.lang,
        value: this.parameters.value ?? ''
      };
    }

    let values = '';
    this.listParameters.forEach((item) => {
      values += `User: ${item.firstLine.trim()}Assistant: ${item.secondLine.trim()}`;
    });

    const newValue = values.trim();
    if (this.parameters.value !== newValue) {
      this.parameters.value = newValue;
      this.updatePromptParameters(this.parameters);
    }

  }

  removeParameter(index: number) {
    this.listParameters.splice(index, 1);
    this.pushParameters();
  }

  addParameter() {
    // Adding the new parameter with placeholder spaces for reactivity
    this.listParameters.push({ firstLine: '', secondLine: '' });
    this.pushParameters();
  }
}
